<template>
    <button
        type="button"
        class="border border-primary-emphasis rounded-md shadow-sm hover:border-primary-secondary"
        :aria-label="label"
        @click="copyTo"
    >
        <clipboard-icon class="h-5 w-5 fill-primary-emphasis" />
    </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ClipboardIcon from "@/components/icons/Clipboard.vue";

export default defineComponent({
    components: { ClipboardIcon },
    props: {
        label: {
            default: () => "Copy to clipboard",
            type: String,
            require: true
        },
        input: {
            default: () => "",
            type: String,
            require: true
        }
    },
    methods: {
        async copyTo(): Promise<void> {
            await navigator.clipboard.writeText(this.input);
        }
    }
});
</script>
